<template>
  <div class="body" v-if="newsList">
    <div class="wrap">
      <p class="wrapTitle clear">新闻中心</p>
      <p class="wrapDesc clear">NEWS CENTER</p>
      <p class="wrapMore clear" @click="toMore('https://www.anquanke.com/subject.html?id=289102')">
        查看更多<right-outlined />
      </p>
      <div class="wrapHot">
        <img
          class="wrapHotLogo"
          src="https://s1.ssl.qhres2.com/static/bd5b931eb3fa7f30.svg"
          alt="logo"
        />
        <img
          class="wrapHotImg"
          :src="activeImg"
          alt="热点新闻"
          @click="toMore(newsList[pitchId].url)"
        />
        <div class="wrapHotNav">
          <p class="wrapHotNavTitle clear" @click="toMore(newsList[pitchId].url)">
            {{ newsList[pitchId].title }}
          </p>
          <p class="wrapHotNavDesc clear">{{ newsList[pitchId].desc }}</p>
          <p class="wrapHotNavCreatedAt clear">{{ newsList[pitchId].createdAt }}</p>
          <Btn :navArr="newsList" :stopId="3" :style="styleBtn" @fetchNav="fetchNav" />
        </div>
      </div>
      <ul class="wrapNews" v-if="newsList.length > 2 && newsList[2]">
        <li class="wrapNewsList" v-for="index in 3" :key="index">
          <p class="wrapNewsListTitle clear">{{ newsList[2 + index].title }}</p>
          <p class="wrapNewsListDesc clear">{{ newsList[2 + index].desc }}</p>
          <p class="wrapNewsListCreatedAt clear">
            <TimeIcon type="icon-shijian" />
            {{ newsList[2 + index].createdAt }}
          </p>
          <p class="wrapNewsListMore clear" @click="toMore(newsList[2 + index].url)">
            查看详情<right-outlined />
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { RightOutlined, createFromIconfontCN } from '@ant-design/icons-vue'
import { getIscNews } from '@/api/2023/index.js'
import { ref, onBeforeMount, watch } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const styleBtn = {
  position: 'absolute',
  left: '56px',
  bottom: '24px'
}
const TimeIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4109126_i6x3sy4e4hr.js'
})
const topicId = 289102
const newsList = ref([
  {
    cover: '', // 封面图地址
    createdAt: '', // 发布时间
    desc: '', // 描述
    title: '', //标题
    url: '' //链接
  }
])
const pitchId = ref(0)
const activeImg = ref('')

onBeforeMount(async () => {
  await fetch()
})
watch(pitchId, () => fetchImg())
function fetchImg() {
  const img = newsList.value[pitchId.value].cover.split('/sdm/229_160_100')
  activeImg.value = img[0] + img[1]
}
function fetch() {
  getIscNews(topicId)
    .then((res) => {
      //成功后的操作...
      newsList.value = res.data.data.list
      fetchImg()
    })
    .catch(() => {})
}
function toMore(url) {
  window.open(url)
}
function fetchNav(newId) {
  pitchId.value = newId
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.body {
  width: 100%;
  min-width: 1280px;
  height: 959px;
  background: url('https://p2.ssl.qhimg.com/t01d35747cab15e5007.png') no-repeat;
  border-bottom: 10px solid #00ab7a;
  padding-top: 100px;
}
.wrap {
  position: relative;
  width: 1280px;
  margin: auto;
  &More {
    position: absolute;
    top: 0;
    right: 0;
    width: 148px;
    height: 52px;
    border-radius: 2px;
    border: 2px solid #00ab7a;
    color: #00ab7a;
    background-color: transparent;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
  &Title {
    font-size: 40px;
    font-weight: bold;
    line-height: 32px;
    color: #00ab7a;
    margin: 0;
  }
  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.6);
    margin: 12px 0 32px;
  }
  &Hot {
    position: relative;
    display: flex;
    &Logo {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    &Img {
      width: 640px;
      height: 396px;
      cursor: pointer;
    }
    &Nav {
      position: relative;
      padding: 62px 56px 0;
      width: 640px;
      height: 396px;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      box-shadow: 0px 4px 10px 0px rgba(0, 31, 138, 0.15);
      &Title {
        cursor: pointer;
        font-weight: bold;
        font-size: 28px;
        line-height: 32px;
        color: #3d3d3d;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &Desc {
        font-size: 16px;
        line-height: 28px;
        color: #666666;
        margin: 24px 0 44px;
      }
      &CreatedAt {
        font-size: 12px;
        line-height: 32px;
        color: #8a9099;
        margin-bottom: 46px;
      }
    }
  }
  &News {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 24px;
    &List {
      cursor: pointer;
      position: relative;
      list-style: none;
      width: 416px;
      height: 213px;
      background: #ffffff;
      padding: 23px 18px;
      color: #3d3d3d;
      box-shadow: 0px 4px 10px 0px rgba(0, 31, 138, 0.15);
      &Title {
        font-size: 20px;
        line-height: 32px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &Desc {
        height: 84px;
        font-size: 16px;
        line-height: 28px;
        color: #666666;
        margin: 8px 0 12px;
        overflow: hidden;
      }
      &CreatedAt {
        font-size: 14px;
        line-height: 32px;
        color: #8a9099;
        img {
          margin-right: 9px;
        }
      }
      &More {
        position: absolute;
        right: 18px;
        bottom: 24px;
        font-size: 16px;
        line-height: 24px;
        color: #00ab7a;
        margin: 0;
      }
    }
    &List:hover {
      background: #00ab7a;
      color: #fff;
      .wrapNewsListDesc,
      .wrapNewsListCreatedAt,
      .wrapNewsListMore {
        color: #fff;
      }
    }
  }
}
</style>
